import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

import { FORTA_GRAY1, FORTA_GRAY3 } from '../../utils/colors';
import FHDurationTrialTime from './fhDurationTrialTime';

interface FHStopwatchProps {
  timerLimit: number;
  startTimer: boolean;
  onStop: (duration: number) => void;
}

function FHStopwatch({ timerLimit, startTimer, onStop }: FHStopwatchProps) {
  const [elapsedTime, setElapsedTime] = useState<number>(0);
  const [intervalId, setIntervalId] = useState<number>();

  useEffect(() => {
    if (startTimer) {
      const id = window.setInterval(() => {
        setElapsedTime((prev) => prev + 1);
      }, 1000);
      setIntervalId(id);
    } else {
      clearInterval(intervalId);
      if (elapsedTime > 0) {
        onStop(elapsedTime);
        setElapsedTime(0);
      }
      setIntervalId(undefined);
    }

    return () => clearInterval(intervalId);
  }, [startTimer]);

  useEffect(() => {
    if (elapsedTime > timerLimit - 1) {
      clearInterval(intervalId);
      if (elapsedTime > 0) {
        onStop(elapsedTime);
        setElapsedTime(0);
      }
      setIntervalId(undefined);
    }
  }, [elapsedTime, timerLimit]);

  return (
    <Box
      sx={{
        p: 1,
        border: `1px solid ${FORTA_GRAY3}`,
        borderRadius: '8px',
        backgroundColor: FORTA_GRAY1,
      }}
    >
      <Typography>
        <FHDurationTrialTime seconds={elapsedTime} />
      </Typography>
    </Box>
  );
}

export default FHStopwatch;
